import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import { useParams, useNavigate } from "react-router-dom";
import { useUser } from "../config/userProvider";
import axios from "axios";
import { apiurl } from "../config/config";
import { DynamicLoader } from "../components/loader";
import BackHeader from "../components/backHeader";
import { BlackButton } from "../components/buttonContainer";
import Card from "../components/card";
import { toast } from "react-toastify";

const ProductDetails = () => {
  const { productId } = useParams();
  const { userData } = useUser();
  const navigate = useNavigate();
  // let vendorObjId = userData?.vendorDetails?.vendorObjId;

  const [productDetails, setProductDetails] = useState(null); // Changed initial state to null
  const [loading, setLoading] = useState(false); // Added loading state
  const [deleteProductLoading, setDeleteProductLoading] = useState(false); // Added loading state
  // const [isDeleted, WantToDelete] = useState(false);
  const [deleteConfirmationPopup, setDeleteConfirmationPopup] = useState(false);

  const fetchProductDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiurl}/admin/v1/product/get/${productId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response && response.data) {
        setProductDetails(response.data.product); // Changed to response.data.product to match expected structure
      }
    } catch (error) {
      console.error("Error fetching product details:", error); // Updated error message for clarity
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (productId) {
  //     fetchProductDetails();
  //   }
  // }, [productId]); // Added productId as a dependency
  useEffect(() => {
    if (productId) {
      fetchProductDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);
  console.log(productDetails);

  const DeleteHandler = () => {
    setDeleteProductLoading(true);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/product/delete/${productId}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          setDeleteProductLoading(false);
          toast.success(
            response?.data?.message
              ? response?.data?.message
              : "Product Deleted Successfully.",
          );
          handleDeleteConfirmationPopup();
          navigate("/products");
        } else {
          setDeleteProductLoading(false);
          toast.error(
            response?.data?.message
              ? response?.data?.message
              : "Failed to delete product.",
          );
        }
      })
      .catch((error) => {
        setDeleteProductLoading(false);
        toast.error("Failed to delete product, Please try again later.");
        handleDeleteConfirmationPopup();
        console.log(error);
      });
  };
  const handleDeleteConfirmationPopup = () => {
    setDeleteConfirmationPopup(!deleteConfirmationPopup);
  };

  return (
    <Layout>
      <Container>
        {loading ? (
          <DynamicLoader maintext="wait" subtext="Fetching Product Details" />
        ) : (
          <div className="h-full w-full px-5 py-3 overflow-scroll">
            {deleteConfirmationPopup && (
              <Card.Confirmation
                message="Are you sure you want to delete this Product?"
                onConfirm={() => DeleteHandler(productId)}
                onClose={handleDeleteConfirmationPopup}
                loading={deleteProductLoading}
                loadingTitle="Deleting..."
              />
            )}
            {/* First Container */}
            <div>
              <BackHeader
                backButton={true}
                link="/products"
                // title={productDetails?.title}
                rightSide={
                  <div className="flex items-center gap-4">
                    {userData?.userType === "superadmin" && (
                      <BlackButton
                        title="Delete"
                        handleSubmit={handleDeleteConfirmationPopup}
                        backgroundColor="rgb(239 68 68)"
                      />
                    )}
                    <div className="flex items-center gap-2 text-gray-600 border-gray-300 py-1.5 rounded-md px-2 text-center">
                      <span className="font-semibold text-sm">Status:</span>{" "}
                      <span
                        className={`border text-xs md:text-sm px-4 p-0.5 rounded-md capitalize font-semibold ${
                          productDetails?.status === "active"
                            ? "bg-green-100 text-green-600 border-green-200"
                            : "bg-red-100 text-red-600 border-red-200"
                        }`}
                      >
                        {productDetails?.status}
                      </span>
                    </div>
                  </div>
                }
              />
            </div>

            {/* Second Container */}
            <div className="flex flex-col w-full md:h-[85%] overflow-scroll mt-5 md:mt-14">
              <p className=" md:p-5 text-lg md:text-xl ld:text-2xl font-bold text-gray-500">
                {productDetails?.title}
              </p>
              {/* Product Details and Image Container */}
              <div className="flex flex-col gap-5 lg:gap-0 lg:flex-row items-center  lg:justify-between w-full">
                {/* Product Details Container */}
                <div className="py-5 md:py-0 md:p-5 flex flex-col justify-between h-full ">
                  <div className="flex flex-col md:flex-row justify-between">
                    <div className="w-full md:w-[49%] text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 rounded-lg mb-2 lg:mb-0">
                      <div className="flex justify-between">
                        <span className="font-semibold">Barcode:</span>{" "}
                        {productDetails?.barcode}
                      </div>
                    </div>
                    <div className="w-full md:w-[49%] text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 mb-2 lg:mb-0 rounded-lg">
                      <div className="flex justify-between">
                        <span className="font-semibold">Product Type:</span>{" "}
                        {productDetails?.product_type}
                      </div>
                    </div>
                  </div>

                  {/* Created At and Updated At */}
                  <div className=" flex flex-col md:flex-row justify-between">
                    <div className="w-full md:w-[49%] text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 rounded-lg mb-2 lg:mb-0">
                      <div className="flex justify-between">
                        <span className="font-semibold">Created At:</span>{" "}
                        {new Date(
                          productDetails?.createdAt,
                        ).toLocaleDateString()}
                      </div>
                    </div>
                    <div className="w-full md:w-[49%] text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 mb-2 lg:mb-0 rounded-lg">
                      <div className="flex justify-between">
                        <span className="font-semibold">Updated At:</span>{" "}
                        {new Date(
                          productDetails?.updatedAt,
                        ).toLocaleDateString()}
                      </div>
                    </div>
                  </div>

                  {/* Vendor ID and Vendor Name */}
                  <div className=" flex flex-col md:flex-row justify-between">
                    <div className="w-full md:w-[49%] text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 rounded-lg mb-2 lg:mb-0">
                      <div className="flex justify-between">
                        <span className="font-semibold">Vendor ID:</span>{" "}
                        {productDetails?.vendorDetails?.vendorId}
                      </div>
                    </div>
                    <div className="w-full md:w-[49%] text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 mb-2 lg:mb-0 rounded-lg">
                      <div className="flex justify-between">
                        <span className="font-semibold">Vendor Name:</span>{" "}
                        {productDetails?.vendorDetails?.vendorName}
                      </div>
                    </div>
                  </div>

                  {/* Vendor Object ID */}
                  <div className="w-full  text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 mb-2 rounded-lg">
                    <div className="flex flex-col md:flex-row gap-2 justify-between wo">
                      <span className="font-semibold">Vendor Object ID:</span>{" "}
                      <span className="break-words">
                        {productDetails?.vendorDetails?.vendorObjId}
                      </span>
                    </div>
                  </div>

                  <div className="w-full text-gray-700 bg-slate-50 border-2 border-slate-200 px-3 md:px-10 py-3 rounded-lg">
                    <div className="flex flex-col md:flex-row gap-2 justify-between">
                      <h3 className="text-lg font-semibold">Tags:</h3>
                      <ul className="list-disc md:pl-5 flex flex-wrap gap-2">
                        {productDetails?.tags?.map((tag, index) => (
                          <li
                            key={index}
                            className="list-none bg-gray-200 text-gray-700 border-gray-500 p-0.5 px-2 rounded-md"
                          >
                            {tag}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Main Image */}
                <div className="w-full md:w-[40%] flex flex-shrink-0 lg:mb-0">
                  <img
                    className="w-full h-auto max-h-fit rounded-lg"
                    src={productDetails?.image}
                    alt={productDetails?.title}
                  />
                </div>
              </div>

              {/* Variants Container */}
              <div className="my-4">
                <h3 className="text-2xl text-slate-500 font-semibold">
                  Variants:
                </h3>
                <ul className="mt-4 space-y-4">
                  {productDetails?.variants?.map((variant, index) => (
                    <li
                      key={index}
                      className="flex flex-col md:flex-row items-start gap-4 bg-slate-50 border border-2 border-slate-200 rounded-lg p-4"
                    >
                      <img
                        className="w-14 h-14 object-cover rounded-lg"
                        src={variant.image}
                        alt={variant.title}
                      />
                      <div className="flex flex-col md:flex-row md:gap-8 flex-1">
                        <h4 className="font-semibold capitalize text-lg text-slate-600">
                          {variant.title}
                        </h4>
                        <p className="mt-1">
                          <span className="font-semibold text-sm text-slate-600">
                            Price:
                          </span>{" "}
                          ${variant.price}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Gallery Container */}
              <div className="my-5">
                <h3 className="text-2xl text-slate-500 font-semibold">
                  Gallery:
                </h3>

                <div className="flex flex-wrap gap-4 mt-4">
                  {productDetails?.images?.map((img, index) => (
                    <img
                      key={index}
                      className=" w-[100%]  md:w-52 rounded-lg"
                      src={img}
                      alt={`Product ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default ProductDetails;
